<template>
<div class="carrow_box">
  <v-card-text>
  <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Uploaded Clean Coffee </h5>
  <table class="table">
    <thead class="thead">
      <tr>
        <th scope="col">File Name</th>
        <th scope="col">Lots</th>
        <th scope="col">Bags</th>
        <th scope="col">Weight</th>
        <th scope="col">Uploaded By</th>
        <th scope="col">Status</th>
        <th scope="col">Date</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="file in paginatedFiles" v-bind:key="file.id">
        <td>{{ file.fileName }}</td>
        <td>{{ file.numberOfLots }}</td>
        <td>{{ file.totalBags }}</td>
        <td>{{ file.totalWeight }}</td>
        <td>{{ file.createdBy }}</td>
        <td>{{ file.status.statusName }}</td>
        <td>{{ file.created | prettyDate }}</td>
        <td class="actions">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
               <v-btn
                color="primary"
                dark
                v-on="on"
                text
                icon
                
              >
                <v-icon small> more_horiz </v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item v-bind:to="'/cleancoffee/' +  file.id  + '/checkoffSettlementDetails'">
                  <v-list-item-title> View </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="dispatchFile(file)" @click="getDispatchFile(file)">
                  <v-list-item-title> Dispatch File </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="dispatchFile(file)" @click="confirmAction(file, 'approve')">
                  <v-list-item-title> Approve </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canBeApproved(file)" @click="confirmAction(file, 'approve')">
                  <v-list-item-title> Approve </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canBeDeclined(file)" @click="confirmAction(file, 'decline')">
                  <v-list-item-title> Decline </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
      </tr>
    </tbody>
  </table>
  </v-card-text>
  <v-card-actions>
    <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
    <v-spacer></v-spacer>
    <v-pagination
    v-model="page"
    :length="numberOfLinks"
    :total-visible="7"
    color="secondary"
                class="accent--text logoutbtn"
  ></v-pagination>
  </v-card-actions>
</div>
</template>
<script>
// import { files } from '../../util/sampledata'
import axios from 'axios'
import config from '../../config'

export default {
	name: 'CataloguesDash',
	data: function () {
		return {
			files: [],
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 5,
			currentPage: 0,
			page: 1,
			permissions: []
		}
	},
	mounted () {
		this.getDataFromApi()
		// this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
		// this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
	},
	watch: {
		files: function () {
			this.paginatedFiles = this.files
			// this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.getUploadedFiles(val - 1)
		}
	},
	computed: {
	},
	methods: {
		getDataFromApi () {
			this.loading = true
			return new Promise((resolve, reject) => {
				const items = this.getUploadedFiles(0)
				const total = items.length
				setTimeout(() => {
					this.loading = false
					resolve({
						items,
						total
					})
				}, 1000)
			})
		},
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_PARCHMENT')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_PARCHMENT')
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		dispatchFile (item) {
			return item.status.statusName === 'APPROVED'
		},
		getDispatchFile (file) {
			const url = config.serverURI + '/files/downloads?filename=dispatch' + file.id

			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const lastUnderscoreIndex = file.fileName.lastIndexOf('_')
					const secondLastUnderscoreIndex = file.fileName.lastIndexOf('_', lastUnderscoreIndex - 1)
					const thirdLastUnderscoreIndex = file.fileName.lastIndexOf('_', secondLastUnderscoreIndex - 1)
					const extractedSuffix = file.fileName.slice(file.fileName.lastIndexOf('_', thirdLastUnderscoreIndex) + 1)
					const itemFileName = 'dispatch_' + extractedSuffix

					// const itemFileName = 'parchment_' + this.$refs.saleNo.value + '_' + this.$refs.season.value?.replace(/\//g, '_') + '.xlsx'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
				})
			// return this.files
		},
		getUploadedFiles (page) {
			const url = config.serverURI + '/upload/parchment/all-clean?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
			axios.get(url)
				.then(response => {
					this.files = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
					this.$emit('updatecleancoffeecount', response.data.page.totalElements)
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		}
	}
}
</script>
<style>
.carrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}
.carrow_box:after, .carrow_box:before {
  bottom: 100%;
  left: 67%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.carrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}
.carrow_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}
</style>
